import React, { useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useQueryClient } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { api_gateway } from '../../../conexoes/api.js'
import {
  mudarDoppleGangerCliente,
  revelarAlterarLogin,
  revelarAlterarSenha,
  revelarDadosContaUsuario,
  revelarPerfilContaUsuario
} from '../../../redux/actions/index'
import { logout } from '../../../services/auth.js'
import { useGlobal } from '../../../stores/useGlobal.js'
import decryptJWT from '../../../utils/decryptJWT.js'
import { isPortal } from '../../../utils/nivelCliente.js'
import { validadorPermissaoElemento } from '../../../utils/verificadorPermissaoElemento.js'
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'
import MensagemErro from '../mensagens/mensagemErro.js'
import MensagemSucesso from '../mensagens/mensagemSucesso.js'

import * as S from './styles'

export default function InfoUsuario(props) {
  const { revelarDadosCliente, setMostrarNotificacao } = useGlobal()
  const [itenSelecionado, setItenSelecionado] = useState('')
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro. Por favor tente novamente mais tarde.'
  )

  const usuarioInicial = 'usuarioInicial'
  const history = useHistory()
  const modal = useRef()
  const despacho = useDispatch()
  const queryClient = useQueryClient()
  const [spinAtivo, setSpinAtivo] = useState(false)
  let dadosContaUsuario = useSelector(
    (state) => state.virtueyesState.revelarDadosContaUsuario
  )
  let perfilContaUsuario = useSelector(
    (state) => state.virtueyesState.revelarPerfilContaUsuario
  )
  let alterarLogin = useSelector(
    (state) => state.virtueyesState.revelarAlterarLogin
  )
  let alterarSenha = useSelector(
    (state) => state.virtueyesState.revelarAlterarSenha
  )
  let estadoExpansaoNavegacao = useSelector(
    (state) => state.manejadorState.expandirNavegacao
  )
  const permissaoElemento = useSelector(
    (state) => state.permissaoState.permissaoElemento
  )

  const cdClienteErp = decryptJWT('clientePrimario')

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  function handleCancelar() {
    props.setRevelarInfosUsuario(false)
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      if (confirmacao === true) {
        window.location.reload()
      } else {
        window.location.reload()
      }
    }
  }

  useEffect(() => {
    async function handlerPermissoes() {
      await validadorPermissaoElemento(
        permissaoElemento,
        'veye/virtueyes/clientes/carregarUsuaruio'
      )
    }
    handlerPermissoes()
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleConta() {
    setItenSelecionado('Conta')
    if (dadosContaUsuario === false) {
      despacho(revelarDadosContaUsuario(true))
      props.setRevelarInfosUsuario(false)
    } else {
      despacho(revelarDadosContaUsuario(false))
      props.setRevelarInfosUsuario(false)
    }
  }

  async function handleDoppelgangerCliente() {
    setSpinAtivo(true)
    await api_gateway.post('/m1/alterar/usuario', {
      dados: {
        ds_cliente_texto: decryptJWT('codigoClienteErpAntigo'),
        cd_pav_cliente: decryptJWT('clienteOriginal')
      },
      condicao: {
        cd_pav_usuario: decryptJWT('codigo')
      },
      painel_virtueyes: true
    })

    let fatContas = []
    const contasUsuario = await api_gateway.get(
      '/m1/consultar/fat_conta/contas_usuario?cd_pav_usuario=' +
        decryptJWT('codigo')
    )
    await Promise.all(
      contasUsuario.data.dados.map((item) => {
        fatContas.push(item.cd_fat_conta)
      })
    )
    if (contasUsuario.data.dados.length == 0) {
      fatContas = [0]
    }
    /*
      PONTO DE ATENÇÃO!
      Os valores de:
          codigoCliente
          codigoClienteErpAntigo
          codigoClienteTexto
          clienteNivel
      Estão recebendo o clienteOriginal, por essa funcionalidade ser usada apenas pela VIRTUEYES. Caso necessário implementar para demais clientes
      e ainda estiverem atuando no LEGADO - dar a devida atenção a este detalhe.
    */
    const request =
      '/m1/servicos/alterar_token?login=' +
      decryptJWT('login') +
      '&email=' +
      decryptJWT('email') +
      '&codigo=' +
      decryptJWT('codigo') +
      '&codigoCliente=' +
      decryptJWT('clienteOriginal') +
      '&codigoClienteErpAntigo=' +
      decryptJWT('clienteOriginal') +
      '&codigoClienteTexto=' +
      decryptJWT('clienteOriginal') +
      '&nomeDeUsuario=' +
      decryptJWT('nomeDeUsuario') +
      '&perfil=' +
      decryptJWT('perfil') +
      '&cdSmsContaUsuario=' +
      decryptJWT('cdSmsContaUsuario') +
      '&id=' +
      decryptJWT('id') +
      '&fatContas=' +
      fatContas +
      '&clienteNivel=' +
      decryptJWT('clienteOriginal') +
      '&tipoPerfil=' +
      decryptJWT('tipoPerfil') +
      '&clientePrimario=' +
      decryptJWT('clientePrimario') +
      '&clienteOriginal=' +
      decryptJWT('clienteOriginal')
    await api_gateway
      .get(request)
      .then(function (response) {
        localStorage.setItem('@veye-Token', response.data.dados.token)
        localStorage.setItem(
          'codigoClienteErpAntigo',
          decryptJWT('codigoClienteErpAntigo')
        )
      })
      .catch(function () {
        setMostrarNotificacao({
          show: true,
          type: 'error',
          title: 'Falha ao Retornar Cliente',
          message: 'Não foi possível retornar o cliente, tente novamente.'
        })
      })

    await api_gateway
      .get(
        '/m1/servicos/token/atualizarLogin?cd_pav_usuario=' +
          decryptJWT('codigo')
      )
      .then(async function () {
        localStorage.removeItem('temLinhasVivo')
        setRevelarMensagemSucesso(true)
      })
      .catch(function (error) {
        setMensagemErro(error.response.data.info)
        setRevelarMensagemErro(true)
      })

    setSpinAtivo(false)
    despacho(mudarDoppleGangerCliente(false))
  }

  function handlePerfil() {
    setItenSelecionado('Perfil')
    if (perfilContaUsuario === false) {
      despacho(revelarPerfilContaUsuario(true))
      props.setRevelarInfosUsuario(false)
    } else {
      despacho(revelarPerfilContaUsuario(false))
      props.setRevelarInfosUsuario(false)
    }
  }

  function handleAlterarLogin() {
    setItenSelecionado('Alterar login')
    if (alterarLogin === false) {
      despacho(revelarAlterarLogin(true))
      props.setRevelarInfosUsuario(false)
    } else {
      despacho(revelarAlterarLogin(false))
      props.setRevelarInfosUsuario(false)
    }
  }

  function handleAlterarSenha() {
    setItenSelecionado('Alterar senha')
    if (alterarSenha === false) {
      despacho(revelarAlterarSenha(true))
      props.setRevelarInfosUsuario(false)
    } else {
      despacho(revelarAlterarSenha(false))
      props.setRevelarInfosUsuario(false)
    }
  }

  async function handleDownloadContrato() {
    setItenSelecionado('Contrato')
    const downloadLink = document.createElement('a')
    const fileName = 'contrato.pdf'
    downloadLink.target = '_blank'
    const url = window.location.href.split('/')
    downloadLink.href = url[0] + '//' + url[2] + '/files/contrato.pdf'
    downloadLink.download = fileName
    downloadLink.click()
    props.setRevelarInfosUsuario(false)
  }

  const handleLogout = () => {
    queryClient.clear()

    logout()
    history.push('/login')
  }

  return (
    <Form ref={modal}>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <div
        className={
          estadoExpansaoNavegacao === true
            ? 'container-infos-usuario'
            : 'container-infos-usuario-2'
        }
      >
        <div
          className={
            estadoExpansaoNavegacao === true
              ? 'triangulo-infos-usuario'
              : 'triangulo-infos-usuario-2'
          }
        />
        <div className="corpo-infos-usuario">
          {revelarDadosCliente && decryptJWT('clienteOriginal') === '1' && (
            <S.NavLinkInfoPrimeiro
              label="Retornar cliente"
              active={itenSelecionado === 'Retornar cliente'}
              onClick={() => handleDoppelgangerCliente()}
            />
          )}
          {cdClienteErp != 2455 &&
            (decryptJWT('codigoClienteErpAntigo') != '2933' ||
              decryptJWT('codigoCliente') == '198') && (
              <S.NavLinkInfo
                label="Conta"
                active={itenSelecionado === 'Conta'}
                onClick={() => handleConta()}
              />
            )}
          {usuarioInicial && (
            <S.NavLinkInfoPrimeiro
              label="Retornar usuario"
              active={itenSelecionado === 'Retornar usuario'}
            />
          )}
          {(decryptJWT('codigoClienteErpAntigo') != '2933' ||
            decryptJWT('codigoCliente') == '198') && (
            <S.NavLinkInfo
              label="Perfil"
              active={itenSelecionado === 'Perfil'}
              onClick={() => handlePerfil()}
            />
          )}

          <S.NavLinkInfo
            label="Alterar senha"
            active={itenSelecionado === 'Alterar senha'}
            onClick={() => handleAlterarSenha()}
          />
          {cdClienteErp != 2455 &&
            (decryptJWT('codigoClienteErpAntigo') != '2933' ||
              decryptJWT('codigoCliente') == '198') && (
              <>
                <S.NavLinkInfo
                  label="Alterar login"
                  active={itenSelecionado === 'Alterar login'}
                  onClick={() => handleAlterarLogin()}
                />
                {!isPortal() && (
                  <>
                    <S.NavLinkInfo
                      label="Contrato"
                      active={itenSelecionado === 'Contrato'}
                      onClick={() => handleDownloadContrato()}
                    />
                  </>
                )}
              </>
            )}

          <S.NavLinkInfoUltimo
            label="Sair"
            onClick={handleLogout}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Cliente original carregado."
              mensagemBotao="OK"
            />
          </div>
        </div>
      )}
    </Form>
  )
}
